export const RENT = 1500
export const SAVED_LISTINGS = 'SAVED_LISTINGS'
export const JWT_TOKEN = 'LISTINGS_BOT_JWT_TOKEN'
export const GOOGLE_STORE_URL =
  'https://chrome.google.com/webstore/detail/homebot-for-chrome/oigjeliojmhdahlmjhackoknjmohedfi'
export const CHROMEBOT_HELP_EMAIL = 'labs@homebot.ai'
export const ZILLOW_URL = 'https://www.zillow.com/'

const CHECK = 'check'
const VERIFY = 'verify'
const SUCCESS = 'success'
const DOWNLOAD = 'download'
const SIGNIN = 'signin'
const CUSTOMER_NOT_ACTIVE = 'customerNotActive'
const FAILURE = 'failure'

export const CHROMEBOT_STEPS = {
  CHECK,
  VERIFY,
  SUCCESS,
  DOWNLOAD,
  SIGNIN,
  CUSTOMER_NOT_ACTIVE,
  FAILURE,
}
export const CHROMEBOT_ORDERED_STEPS = [
  CHECK,
  VERIFY,
  SUCCESS,
  DOWNLOAD,
  SIGNIN,
  CUSTOMER_NOT_ACTIVE,
  FAILURE,
]

export const CHROMEBOT_SUCCESSFULLY_INSTALLED = 'chromebot:extension-installed'
export const CHROMEBOT_EVENT_SOURCE = 'homebot-for-chrome'
